import dayjs from 'dayjs'

export const formatShiftCloseoutHistoryDate = (
    date: string | Date
): { date: string; time: string; weekday: string } => {
    const value = dayjs(date)
    const weekday = value.format('dddd')

    return {
        date: value.format('D. M. YYYY'),
        time: value.format('HH:mm'),
        weekday: weekday.charAt(0).toUpperCase() + weekday.slice(1),
    }
}
